import { useLazyQuery } from '@apollo/client';
import { useState } from 'react';
// import commonMessage from '../../configs/commonMessage';
import { GET_BY_PROMO_CODE_AND_TEAM_ID } from '../../graphql/queries';
import { timeoutFunc } from '../../utils/commonUtils';

let timeout = 0;

const useIsUniquePromotionCode = (params = {}) => {
  const { teamId } = params;
  const [isValidCode, setIsValidCode] = useState(null);
  const [isNotValidCodeMessage, setIsNotValidCodeMessage] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [getPromoCodeCheck] = useLazyQuery(GET_BY_PROMO_CODE_AND_TEAM_ID, {
    onCompleted: (res) => {
      const isUnique = res?.unique;
      if (isUnique) {
        setIsValidCode(true);
        setIsNotValidCodeMessage(null);
        setIsFetching(false);
      } else {
        setIsValidCode(false);
        setIsNotValidCodeMessage('Promotion code is not available');
        setIsFetching(false);
      }
    },
    onError: (err) => {
      setIsValidCode(false);
      setIsNotValidCodeMessage(err?.message);
    },
  });

  const onValidate = (code) => {
    if (code === '') {
      // setIsNotValidCodeMessage(commonMessage.invalidType('promotion code'));
      setIsValidCode(false);
    }
    timeout = timeoutFunc(
      timeout,
      async () => {
        if (code !== '') {
          setIsFetching(true);
          setIsValidCode(true);
          setIsNotValidCodeMessage(null);
          getPromoCodeCheck({
            variables: {
              promo_code: code,
              team_id: teamId,
            },
          });
        }
      },
      2000
    );
    return null;
  };

  const validateStatus = () => {
    if (isFetching) {
      return 'validating';
    }
    if (!isFetching && isValidCode && isValidCode !== null) {
      return 'success';
    }
    if (!isFetching && !isValidCode && isValidCode !== null) {
      return 'error';
    }
    return '';
  };

  return {
    isValidCode,
    isNotValidCodeMessage,
    isFetching,
    onValidate,
    validateStatus,
  };
};

export default { useIsUniquePromotionCode };
